module.exports = __webpack_public_path__ + "img/1.20.1_Russian_road_sign.99764677.svg";